<template>
  <div id="app">
    <!-- Idle session timeout (EB2-56029) for apps that authenticate with JWT -->
    <SessionTimeout v-if="isJwtApplication" />
    <div
      v-if="$route.meta.jwtRequiresAuth && application == 'employee'"
      style="background-color:#F4F5FD; height:100%;"
    >
      <SiderbarV2
        v-if="$store.state.showSidebar"
        style="float:left"
      />

      <AppHeaderEmployee v-if="$route.meta.jwtRequiresAuth && application == 'employee'" />
      <!-- ------------render content---------------->
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
    </div>

    <div v-else>
      <!-- ------------render Header---------------->
      <SidebarRemingtonSeeds
        v-if="$route.meta.jwtRequiresAuth && application == 'remington_seeds' && $store.state.showSidebar"
        style="float:left"
      />
      <AppHeaderRemingtonSeeds v-if="$route.meta.jwtRequiresAuth && application == 'remington_seeds'" />

      <AppHeader v-if="$route.meta.requiresAuth && $route.name !== 'userexam' && $route.name !== 'userTraining' && (application == 'thirdparty' || application == 'remdiation')" />
      <AppHeaderPri v-else-if="$route.meta.requiresAuth && $route.name !== 'userexam' && $route.name !== 'userTraining' && application == 'pri'" />
      <!-- <Layout v-if="$route.meta.requiresAuth && $route.name !== 'home' && $route.name !== 'preview'"/> -->

      <!-- ------------render content---------------->
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
    </div>
  </div>
</template>

<script>
import AppHeader from "./components/header/header";
import AppHeaderEmployee from "./components/header/employeeHeader";
import AppHeaderRemingtonSeeds from "./components/header/remingtonSeedsHeader";
import AppHeaderPri from "./components/header/header-pri";
import SiderbarV2 from "./components/SidebarV2/sidebarv2.vue";
import SidebarRemingtonSeeds from "./components/SidebarV2/sidebarRemingtonSeeds.vue";
import SessionTimeout from "./components/sessionTimeout/sessionTimeout.vue";

//import Layout from "./containers/layout";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import { EventBus } from "@/event-bus.js";
import { HTTP } from "@/utils/HTTP";
import { getAccessToken, refreshAccessToken } from "./utils/auth-requests";

// import 'custom.scss'

export default {
  name: "app",
  data () {
    return {
      userType: null,
      isLoading: false,
      application: process.env.VUE_APP_APPLICATION,
      isJwtApplication: process.env.VUE_APP_APPLICATION == "employee" || process.env.VUE_APP_APPLICATION == "remington_seeds",
    };
  },
  components: {
    AppHeader,
    AppHeaderEmployee,
    AppHeaderRemingtonSeeds,
    AppHeaderPri,
    SiderbarV2,
    SidebarRemingtonSeeds,
    SessionTimeout
    //Layout
  },
  mounted () {
    console.clear();
    this.userType = localStorage.getItem( "userType" );
    let sidbar = localStorage.getItem( "showSidebar" );
    this.$store.state.showSidebar = sidbar == null ? true : sidbar == '1' ? true : false;
    console.log( '%c Stop! ', 'font-size: 40px; font-weight: 600; color: red; -webkit-text-stroke: 1px #000000;' );
    let lang = localStorage.getItem( "formTranslations" );
    if ( lang ) {
      var res = lang.split( "," );
      this.$store.state.form1.formTranslations = res;
    }
    this.setAlign();
  },
  methods: {
    setAlign () {
      let selectedLang = localStorage.getItem( "formDefaultLanguage" );
      if ( selectedLang == "arabic" || selectedLang == "hebrew" ) {
        this.$store.state.rightAlign = true;
      } else {
        this.$store.state.rightAlign = false;
      }
    },
    async getFormLanguages () {
      try {
        let result = await HTTP( "post", "v1/getclientexams", {
          formId: formId,
        } );
        if ( result.data && result.data.exams && result.data.exams.length ) {
          this.formExams = result.data.exams;
        }
      } catch ( error ) {
        return error;
      }
    },
  },
  async created () {
    if ( process.env.VUE_APP_APPLICATION == "employee" || process.env.VUE_APP_APPLICATION == "remington_seeds" ) {
      // The Vuex store only lives in memory, so a fresh page load (e.g. the
      // window.location.href redirect right after login) always starts with
      // accessToken: null here, even though localStorage already has a valid
      // one. Rehydrate it first so getAccessToken() below recognizes a
      // just-issued token as valid instead of assuming the session is stale
      // and falling through to refreshAccessToken() — which can wipe
      // localStorage on a failed/cookie-less refresh and log the user
      // straight back out.
      let storedAccessToken = localStorage.getItem( "accessToken" );
      if ( storedAccessToken ) {
        this.$store.commit( "SET_ACCESS_TOKEN", storedAccessToken );
      }
      //Gets a access token if the refresh token is still valid
      await getAccessToken( this.$store );
    }
  },
};
</script>

<style>
body {
  overflow: hidden;
  height: 100vh;
}
#app {
  height: 100vh;
  /* font-family: "Avenir", Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}
/* ::-webkit-scrollbar-track
  {
    box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    -moz-box-shadow: inset 0 0 6px rgba(0,0,0,0.3) !important;
    border-radius: 5px;
    background-color: #F5F5F5;
  } */
::-webkit-scrollbar {
  width: 5px;
  -moz-width: 13px !important;
  background-color: #f5f5f5;
}
::-webkit-scrollbar-thumb {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  -moz-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3) !important;
  background-color: #f8f9fa;
}

.click-cursor:hover {
  cursor: pointer;
}
.card-wrapper {
  box-shadow: 0 0px 0px rgba(0, 0, 0, 0.15);
  transition: box-shadow 0.3s ease-in-out;
}
.card-wrapper:hover {
  box-shadow: 2px 5px 10px 0px #888888;
  transition: box-shadow 0.3s ease-in-out;
}
.form-control-small .vs__dropdown-toggle {
  height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}
.form-control-small .multiselect__tags {
  height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
  min-height: 0;
}
</style>
